const clbxFinance = () => import('@/views/cwgl/finance/clbxFinance.vue');
const fybxFinance = () => import('@/views/cwgl/finance/fybxFinance.vue');
const clbxCount = () => import('@/views/cwgl/finance/clbxCount.vue');
const clbxCountReview = () => import('@/views/cwgl/finance/clbxCountReview.vue');
const fybxCount = () => import('@/views/cwgl/finance/fybxCount.vue');
const dkTaxCount = () => import('@/views/cwgl/finance/dkTaxCount.vue');

export default [
  {
    path: '/cwgl/finance/clbx',
    name: 'ClbxFinancePage',
    meta: {
      title: '差旅报销财务',
      path: ['财务管理', '差旅报销财务'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: clbxFinance
  },
  {
    path: '/cwgl/finance/fybx',
    name: 'FybxFinancePage',
    meta: {
      title: '费用报销财务',
      path: ['财务管理', '费用报销财务'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: fybxFinance
  },
  {
    path: '/cwgl/finance/clbxCount',
    name: 'ClbxCountPage',
    meta: {
      title: '差旅报销统计',
      path: ['财务管理', '差旅报销统计'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: clbxCount
  },
  {
    path: '/cwgl/finance/clbxCount/review',
    name: 'ClbxCountPage',
    meta: {
      title: '差旅报销统计',
      path: ['财务管理', '差旅报销统计'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: clbxCountReview
  },
  {
    path: '/cwgl/finance/fybxCount',
    name: 'FybxCountPage',
    meta: {
      title: '费用报销统计',
      path: ['财务管理', '费用报销统计'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: fybxCount
  },
  {
    path: '/cwgl/finance/dkTaxCount',
    name: 'dkTaxCount',
    meta: {
      title: '抵扣税额统计',
      path: ['财务管理', '抵扣税额统计'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: dkTaxCount
  }
];
